#import "~/graphql/fragments/sections/discover/articlePreview.graphql"
#import "~/graphql/fragments/sections/discover/dossierPreview.graphql"
#import "~/graphql/fragments/sections/discover/eventPreview.graphql"
#import "~/graphql/fragments/sections/discover/newsPreview.graphql"
#import "~/graphql/fragments/sections/discover/projectPreview.graphql"
#import "~/graphql/fragments/sections/discover/grantAwardedPreview.graphql"

fragment featuredEntriesField on EntryInterface {
    ... articlePreview
    ... dossierPreview
    ... eventPreview
    ... newsPreview
    ... projectPreview
    ... grantAwardedPreview
}
